// @flow
import dynamic from 'next/dynamic'

const AuthLayout = dynamic(() => import('./authLayout'), {
  ssr: false
})

export { AuthLayout }
